import { createReduxSlice } from '@app/store/redux_slice'

const wasRefreshedDuringSsrSlice = createReduxSlice<boolean>('was_refreshed_during_ssr')

export const setWasRefreshedDuringSsr = (value: boolean) => wasRefreshedDuringSsrSlice.set(value)

export const getWasRefreshedDuringSsr = () => wasRefreshedDuringSsrSlice.get()
